<h2>{{ productLinkTitle() }}</h2>
@if (productSKUs$ | async; as productSKUs) {
  @if (productSKUs.length) {
    <div class="product-list-container">
      <div class="product-list">
        <swiper [config]="swiperConfig">
          @for (sku$ of productSKUs; track sku$) {
            <ng-template swiperSlide let-data>
              @if (lazyFetch(data.isVisible, sku$) | async; as sku) {
                <ish-product-item
                  ishProductContext
                  [sku]="sku"
                ></ish-product-item>
              }
            </ng-template>
          }
        </swiper>
      </div>
    </div>
  }
}

<ng-container>
  @if (categories.length) {
    <div class="product-list-container">
      <div class="product-list">
        <swiper [config]="swiperConfig">
          @for (categoryid of categories; track categoryid) {
            <ng-template swiperSlide let-data>
              <custom-category-tile ishCategoryContext [uniqueId]="categoryid"  [categoryUniqueId]="categoryid" />
            </ng-template>
          }
        </swiper>
      </div>
    </div>
  }
</ng-container>
